(ns dre.utils
  (:require
   [applied-science.js-interop :as j]
   [clojure.string :as str]
   [clojure.walk :as walk]
   [goog.Uri]))

(defn aborted-request?
  [response]
  (or
   (= :aborted (:problem response))
   (= "aborted" (:problem response))
   (= "The user aborted a request." (:problem-message response))
   (= "signal is aborted without reason" (:problem-message response))))

(defn resolve-url
  "Returns absolute url by resolving relative url to domain + path of
  absolute url."
  [absolute relative]
  (str
   (.resolve (goog.Uri. (str/trim absolute))
             (goog.Uri. (str/trim relative)))))

(defn not-blank
  [x]
  (when-not (str/blank? x)
    x))

(def localhost?
  (let [hostname (j/get-in js/window [:window :location :hostname])]
    (or (= "127.0.0.1" hostname) (= "localhost" hostname) (= "local-ui.doctorevidence.com" hostname))))

(defn dev-env?
  [env]
  (or (= :local env) (= :dev env)))

(defn prod-env?
  [env]
  (= :prod env))

(defn beta-env?
  [env]
  (= :beta env))

(defn dre-user?
  [user]
  (or
   (-> user :docdata/client-id (= "3"))
   (-> user :docdata/client-id (= "231850759"))))

(defn dev-role?
  [user]
  (contains? (set (:roles user)) "datahubdev"))

(defn admin-role?
  [user]
  (contains? (set (:roles user)) "docsearchadmin"))

(defn sanofi-csv-export-role?
  [user]
  (contains? (set (:roles user)) "sanoficsvexport"))

(defn condensates-role?
  [user]
  (contains? (set (:roles user)) "condensates"))

(defn restricted-role?
  [user]
  (contains? (set (:roles user)) "datahubrestricted"))

(defn datahub-role?
  [user env]
  (or
   (and (not (dev-env? env))
        (contains? (set (:roles user)) "datahub"))
   (and (dev-env? env)
        (contains? (set (:roles user)) "datahubdev"))))

(defn user-id
  [user]
  (:user-id user))

(defn allowed-sources
  [user]
  (set (:allowed-sources user)))

(defn allowed-source?
  [source user]
  (contains? (allowed-sources user) source))

(defn roles-hash
  [user]
  (:roles-hash user))

(defn counts->percentages
  "Returns a collection of percentages given the
  collection of counts."
  ([counts total]
   (map #(float (* (/ %1 total) 100)) counts))
  ([counts]
   (counts->percentages counts (reduce + counts))))

(defn stringify-keys-with-namespaces
  "Apply the string n to the supplied structure m as a namespace."
  [m]
  (walk/postwalk
   (fn [x]
     (if (keyword? x)
       (subs (str x) 1)
       x))
   m))

(defn filter-map
  "Filters a map by the keys that match pred"
  [m pred]
  (select-keys m (filter pred (keys m))))

(defn tag-name
  "I am sure this exists elsewhere"
  [kw]
  (str (namespace kw) "/" (name kw)))
